import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShieldX, ArrowLeft, Home, LogIn } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { useAuth } from '../../lib/auth';
export function UnauthorizedPage() {
  const navigate = useNavigate();
  const {
    isAuthenticated,
    logout
  } = useAuth();
  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4" data-id="element-514">
      <div className="text-center max-w-md" data-id="element-515">
        <div className="h-24 w-24 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-516">
          <ShieldX className="h-12 w-12 text-red-600" data-id="element-517" />
        </div>

        <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-518">Akses Ditolak</h1>

        <p className="text-gray-600 mb-8" data-id="element-519">
          Maaf, Anda tidak memiliki izin untuk mengakses halaman ini. Silakan
          hubungi administrator jika Anda merasa ini adalah kesalahan.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-520">
          <Button variant="outline" onClick={() => navigate(-1)} className="gap-2" data-id="element-521">
            <ArrowLeft className="h-4 w-4" data-id="element-522" />
            Kembali
          </Button>

          <Link to="/" data-id="element-523">
            <Button variant="outline" className="gap-2 w-full sm:w-auto" data-id="element-524">
              <Home className="h-4 w-4" data-id="element-525" />
              Beranda
            </Button>
          </Link>

          {isAuthenticated ? <Button onClick={handleLogout} className="bg-primary-600 hover:bg-primary-700 gap-2" data-id="element-526">
              <LogIn className="h-4 w-4" data-id="element-527" />
              Login Ulang
            </Button> : <Link to="/login" data-id="element-528">
              <Button className="bg-primary-600 hover:bg-primary-700 gap-2 w-full sm:w-auto" data-id="element-529">
                <LogIn className="h-4 w-4" data-id="element-530" />
                Login
              </Button>
            </Link>}
        </div>
      </div>
    </div>;
}